import {useGoogleLogin} from '@react-oauth/google';
import {useMutation} from '../../../../common/hooks/QueryHooks';
import {LoggedInEnterprise} from '../Types';
import {useAuth} from '../../providers/AuthProvider';

const useLoginWithGoogleToken = () => {
	const {login, logout} = useAuth();
	const {mutate, isLoading} = useMutation<LoggedInEnterprise>('enterpriser/auth/verify/google-auth-token');

	const loginWithGoogle = async (token: string) => {
		try {
			const data = {authToken: token};
			const res = await mutate({data});
			login(res);
		} catch (error) {
			logout();
		}
	};

	const googleLoginButtonHandler = useGoogleLogin({
		flow: 'implicit',
		onSuccess: async (codeResponse) => {
			loginWithGoogle(codeResponse.access_token);
		},
		onError: (errorResponse) => console.log(errorResponse),
	});

	return {googleLoginButtonHandler, isLoading};
};

export default useLoginWithGoogleToken;
